// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectPortfolioStatisticsMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_PORTFOLIO_STATISTICS_RESPONSE);
        this.DataArray = [];
    }
}
export class DirectPortfolioStatistic {
    constructor() {
        this.Date = null; // приходит в FIELD_DATE[12] - Значение “день”,
        this.Percent = null; // приходит в FIELD_PERCENT[729] - Значение “процентов”,
        this.AbsoluteAmount = null; // приходит в FIELD_AMOUNT[7] - Значение “абсолютное”,
        this.IsBest = null; // приходит в FIELD_TYPE[53] - байтовое поле, в рамках тек.задачи, будет использоваться для передачи признака “best” = 1 или “worst” = 0,
        this.TradableInstrumentId = null; // приходит в FIELD_TRADABLE_INSTRUMENT_ID[655] - Идентификатор инструмента,
        this.RouteId = null; // приходит в FIELD_ROUTE_ID[85] - Идентификатор котировочного роута
    }
}
